import { createSlice } from "@reduxjs/toolkit";

const litigaitons = JSON.parse(localStorage.getItem("litigations"));
const initialState = {
  value: litigaitons || [],
};

export const litigationsSlice = createSlice({
  name: "litigaitons",
  initialState,
  reducers: {
    setLitigations: (state, action) => {
      state.value = action.payload;
      localStorage.setItem("litigations", JSON.stringify(action.payload));
    },
  },
});

export const { setLitigations } = litigationsSlice.actions;
export default litigationsSlice.reducer;
